module.exports = __webpack_public_path__ + "static/media/fiberglassIcon.fdf7d612.svg";